export const parseApiDateTime = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value).trim();
  if (!raw) return null;

  const dateOnlyMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const normalized = raw.includes(' ') ? raw.replace(' ', 'T') : raw;
  const hasTime = normalized.includes('T');
  const hasTimezone = /(Z|[+-]\d{2}:\d{2})$/.test(normalized);
  const candidate = hasTime && !hasTimezone ? `${normalized}Z` : normalized;
  const parsed = new Date(candidate);

  return Number.isNaN(parsed.getTime()) ? null : parsed;
};
